import { render, staticRenderFns } from "./applyGrap.vue?vue&type=template&id=2c3d9b84&scoped=true&"
import script from "./applyGrap.vue?vue&type=script&lang=js&"
export * from "./applyGrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d9b84",
  null
  
)

export default component.exports